/* ════════════════════════════════════════════════════════════════
   OB MEMBERSHIP HOME PAGE — behavior
   Variant pickers, buy buttons, sticky bar, FAQ accordion.
   Cart UI (drawer, toast, header count) is owned by the sitewide
   ob-cart-drawer snippet (window.OBCart); this script falls back to
   a local minimal implementation only if the snippet is absent.
   Selling plans (Recharge native) ride along on /cart/add.js.
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__obMembershipInit) return;
  window.__obMembershipInit = true;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* ── Card data ──────────────────────────────────────────────── */
  var cards = [].slice.call(document.querySelectorAll('[data-tier-card]'));
  var cardData = {};

  cards.forEach(function (card) {
    var el = card.querySelector('[data-tier-json]');
    if (!el) return;
    try { cardData[card.id] = JSON.parse(el.textContent); } catch (e) { cardData[card.id] = null; }
  });

  function selection(card) {
    var vals = [];
    [].slice.call(card.querySelectorAll('.opt')).forEach(function (o) {
      var sel = o.querySelector('[role="radio"][aria-checked="true"]');
      vals.push(sel ? sel.dataset.value : null);
    });
    return vals;
  }

  function currentVariant(card) {
    var d = cardData[card.id];
    if (!d || !d.variants || !d.variants.length) return null;
    if (!d.hasOptions) return d.variants[0];
    var sel = selection(card);
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i], hit = true;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] && v.options[j] !== sel[j]) { hit = false; break; }
      }
      if (hit) return v;
    }
    return d.variants[0];
  }

  function variantLabel(card) {
    var d = cardData[card.id];
    if (!d || !d.hasOptions) return '';
    return selection(card).filter(Boolean).join(' · ');
  }

  function syncCard(card) {
    var v = currentVariant(card);
    if (!v) return;
    var priceEl = card.querySelector('[data-price]');
    if (priceEl) priceEl.textContent = money(v.price);
    var img = card.querySelector('.jn-tier-media img, .jl-media img');
    if (img && v.image) {
      img.src = v.image;
      var d = cardData[card.id];
      img.alt = (d ? d.name : '') + (variantLabel(card) ? ' in ' + variantLabel(card) : '');
    }
    var addBtns = card.querySelectorAll('[data-add],[data-now]');
    [].slice.call(addBtns).forEach(function (b) {
      b.disabled = v.available === false;
      if (v.available === false) b.textContent = 'Sold Out';
    });
  }

  /* ── Option radio groups ────────────────────────────────────── */
  [].slice.call(document.querySelectorAll('[data-tier-card] [role="radiogroup"]')).forEach(function (g) {
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[role="radio"]');
      if (!b || b.disabled) return;
      [].slice.call(g.querySelectorAll('[role="radio"]')).forEach(function (r) {
        r.setAttribute('aria-checked', r === b ? 'true' : 'false');
      });
      var opt = g.closest('.opt'), head = opt && opt.querySelector('.opt-label .val');
      if (head) head.textContent = '— ' + b.dataset.value;
      var card = g.closest('[data-tier-card]');
      if (card) { syncCard(card); syncBar(card); }
    });
  });

  /* ── Cart: delegate to the sitewide drawer when present ─────── */
  var OB = window.OBCart || null;

  /* Local fallback, used only if the ob-cart-drawer snippet is absent */
  var localToast = (function () {
    var toast = document.getElementById('obToast'), toastMsg = document.getElementById('obToastMsg'), tTimer;
    return function (m) {
      if (!toast) return;
      toastMsg.textContent = m;
      toast.classList.add('is-on');
      clearTimeout(tTimer);
      tTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2200);
    };
  })();

  function notify(m) { if (OB) OB.toast(m); else localToast(m); }

  function addToCart(card, goCheckout) {
    var v = currentVariant(card);
    var d = cardData[card.id];
    if (!v || !d) return Promise.resolve();
    var item = { id: v.id, quantity: 1 };
    if (d.sellingPlanId) item.selling_plan = d.sellingPlanId;
    if (OB && !goCheckout) OB.nextMessage = d.name + ' added';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function () {
      if (goCheckout) { window.location.href = '/checkout'; return; }
      /* With OBCart present, its cart-API watcher refreshes, opens, and
         toasts. Without it, there is no drawer on the page; toast only. */
      if (!OB) notify(d.name + ' added');
    }).catch(function (err) {
      if (OB) OB.nextMessage = null;
      notify((err && err.description) || 'Could not add to cart');
    });
  }

  function flash(btn) {
    if (!btn) return;
    var t = btn.textContent;
    btn.textContent = 'Added';
    setTimeout(function () { btn.textContent = t; }, 1300);
  }

  cards.forEach(function (card) {
    var add = card.querySelector('[data-add]'), now = card.querySelector('[data-now]');
    if (add) add.addEventListener('click', function () { addToCart(card, false); flash(this); });
    if (now) now.addEventListener('click', function () { addToCart(card, true); });
    card.addEventListener('click', function () { syncBar(card); });
    syncCard(card);
  });

  /* ── Sticky buy bar ─────────────────────────────────────────── */
  var bar = document.getElementById('jnBar'), barName = document.getElementById('barName'),
      barMeta = document.getElementById('barMeta'), barAdd = document.getElementById('barAdd');
  var current = cards.length > 1 ? cards[1] : cards[0];

  function syncBar(card) {
    if (!bar || !card) return;
    current = card;
    var d = cardData[card.id], v = currentVariant(card);
    if (!d || !v) return;
    barName.textContent = d.name;
    var label = variantLabel(card);
    barMeta.textContent = (label ? label + ' · ' : '') + money(v.price) + (d.perYear ? ' a year' : '');
    [].slice.call(document.querySelectorAll('.jn-bar-pick button')).forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.jump === card.id ? 'true' : 'false');
    });
    cards.forEach(function (c) { c.classList.toggle('is-target', c === card); });
  }
  if (current) syncBar(current);

  if (barAdd) barAdd.addEventListener('click', function () { if (current) { addToCart(current, false); flash(this); } });
  [].slice.call(document.querySelectorAll('.jn-bar-pick button')).forEach(function (b) {
    b.addEventListener('click', function () {
      var card = document.getElementById(b.dataset.jump);
      if (!card) return;
      syncBar(card);
      window.scrollTo({ top: card.getBoundingClientRect().top + window.scrollY - 130, behavior: 'smooth' });
    });
  });

  if ('IntersectionObserver' in window && bar) {
    var grid = document.querySelector('.jn-tier-grid, .jl-grid');
    if (grid) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        var up = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-up', up);
        document.body.dataset.bar = up ? 'up' : 'down';
      }, { threshold: 0 }).observe(grid);
    }
  }

  /* ── FAQ accordion (parked section support) ─────────────────── */
  [].slice.call(document.querySelectorAll('.jn-faq')).forEach(function (faq) {
    faq.addEventListener('click', function (e) {
      var q = e.target.closest('.jn-faq-q');
      if (!q) return;
      var item = q.parentElement, a = item.querySelector('.jn-faq-a');
      var open = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
    });
  });
})();
